import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import SweetAlert from 'react-bootstrap-sweetalert';
import { Row } from "components/Layout";
import PageWithModal from "components/Page/PageWithModal";
import NTMButtonRow from "components/FilterAndSearch/NTMButtonRow";
import NTMButton from "components/Buttons/NTMButton";
import { useGetDevices } from "service/ProjectService"
import { useSettings } from "service/SettingsService";
import { roles, settings as SETTINGS } from "../../constants";
import SettingsContainer from "./SettingsContainer";
import "./_settings.scss"


export default function SettingsAgrismartDss() {

	let [selected, setSelected] = useState('Progetto');
	let [alert, setAlert] = useState(null);
	let [device, setDevice] = useState();

	let project = useSelector(store => store.session.project)
	let user = useSelector(store => store.users.data)
	let { crop } = useParams()

	let { devices } = useGetDevices()
	let { settings, saveSettings, deleteSetting, getSettingValue, changeSetting } = useSettings()

	function closeAlert() {
		setAlert(null);
	}

	function openConfirm() {
		setAlert(<SweetAlert success title={"Salvato correttamente"} onConfirm={closeAlert} onCancel={closeAlert} />);
	}

	function save() {
		saveSettings().then(openConfirm)
	}

	function changeDevice(id) {
		let device = devices.find(d => d.id === parseInt(id))
		setDevice(device)
	}

	if (!settings || !project || !user || !crop) return null
	if (!device && devices.length > 0) {
		setDevice(devices[0].deviceId)
	}

	const { projectTypeId, projectTypeName } = project;
	let filters = ['Progetto', 'Dispositivo'];
	let deviceSettings = SETTINGS.settingItems[projectTypeName].filter(s => s.scope.includes(SETTINGS.scopes.DEVICE));
	let projectSettings = SETTINGS.settingItems[projectTypeName].filter(s => s.scope.includes(SETTINGS.scopes.PROJECT));
	let typeSettings = SETTINGS.settingItems[projectTypeName].filter(s => s.scope.includes(SETTINGS.scopes.TYPE));
	let settingGroups = SETTINGS.groups[projectTypeName].filter(g => g.name.includes(crop) || g.name.includes("dss"))

	if (roles.isSuperUser(user)) {
		filters.push(projectTypeName);
	}

	return (
		<PageWithModal>
			<Row style={{ paddingLeft: "1rem" }}>
				<NTMButtonRow
					buttons={filters}
					onClick={setSelected}
					allButton={false}
					selected={selected}
				/>
			</Row>
			<Row>
				{
					selected === 'Dispositivo' &&
					<>
						<Row style={{ paddingLeft: "1rem" }}>
							<select value={device.id} onChange={e => changeDevice(e.target.value)}>
								{devices.map(d =>
									<option key={d.id} value={d.id}>{d.label || d.deviceId}</option>
								)}
							</select>
						</Row>
						<Row>
							<div style={{ padding: "1rem", fontStyle: "italic" }}>Queste impostazioni verranno applicate solo all'attuale dispositivo. Il tasto elimina compare solo in caso in cui il valore sia stato modificato sovrascrivendo il valore di default</div>
							<SettingsContainer
								scope={SETTINGS.scopes.DEVICE}
								settingItems={deviceSettings}
								settingGroups={settingGroups}
								projectTypeId={projectTypeId}
								projectId={project.id}
								deviceId={device.id}
								getSettingValue={getSettingValue}
								changeSetting={changeSetting}
								deleteSetting={deleteSetting}
							/>
						</Row>
					</>
				}
				{
					selected === 'Progetto' &&
					<Row>
						<div style={{ padding: "1rem", fontStyle: "italic" }}>Queste impostazioni verranno applicate solo all'attuale progetto. Il tasto elimina compare solo in caso in cui il valore sia stato modificato sovrascrivendo il valore di default</div>
						<SettingsContainer
							scope={SETTINGS.scopes.PROJECT}
							settingItems={projectSettings}
							settingGroups={settingGroups}
							projectTypeId={projectTypeId}
							projectId={project.id}
							getSettingValue={getSettingValue}
							changeSetting={changeSetting}
							deleteSetting={deleteSetting}
						/>
					</Row>
				}
				{
					selected === projectTypeName &&
					<Row>
						<div style={{ padding: "1rem", fontStyle: "italic" }}>Queste impostazioni verranno applicate a tutti i progetti di questa tipologia e diventeranno effettivi immediatamente a meno che il valore non sia stato sovrascritto nella sezione "impostazioni" del singolo progetto</div>
						<SettingsContainer
							scope={SETTINGS.scopes.TYPE}
							settingItems={typeSettings}
							settingGroups={settingGroups}
							projectTypeId={projectTypeId}
							getSettingValue={getSettingValue}
							changeSetting={changeSetting}
							deleteSetting={deleteSetting}
						/>
					</Row>
				}
			</Row>
			<Row style={{ padding: "1rem" }}>
				<NTMButton primary onClick={save}>{"Salva"}</NTMButton>
			</Row>
			{alert}
		</PageWithModal>
	);
}
